import {
	Button
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { useState } from 'react';
import { useActions } from 'kea';

import grouplogic from 'src/store/group';




const RemoveGroupDialog = ({ group, reset }) => {
	const [open, setOpen] = useState(false);

	const { remove } = useActions(grouplogic);

	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
	}

	const handleRemove = () => {
		let validated = true;
		if (!group) {
			validated = false;
		}
		if (validated) {
			remove(group);
			reset();
			setOpen(false);
		}
	}

	return (
		<div>
			<Button
				color="primary"
				variant="contained"
				aria-label="add"
				onClick={handleClickOpen}
				size='large'
			>
				Remove
			</Button>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="group-dialog-title"
				aria-describedby="group-dialog-description"
			>
				<DialogTitle id="group-dialog-title">
					{"Remove Group?"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="group-dialog-description">
						Remove the Group?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleRemove} color="primary">
						Confirm Remove
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}


export default RemoveGroupDialog
